import { ChangeDetectorRef, Directive, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ICrumb } from '@df/catalog/model';
import { Meta } from '@df/core/meta/meta';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BreadcrumbsComponentDef implements OnInit, OnDestroy, OnChanges {
    /**
     * Current crumbs list
     */
    protected breadcrumbs: ICrumb[] | undefined;

    /**
     * Change subscriptions
     */
    private subscriptions = new Subscription();

    /**
     * Breadcrubms subscription (they may change withotu meta changes)
     */
    private breadcrumbsSubscription?: Subscription;

    /**
     * If component is initiated
     */
    private initiated = false;

    /**
     * Tracker function
     * Name by index is kept for legacy support, in fact we track by url
     */
    trackByIndex = (index: number, crumb: ICrumb) => crumb.url;

    /**
     * Class dependencies
     */
    constructor(
        private ref: ChangeDetectorRef,
        private meta: Meta
    ) {
        this.ref.detach();
    }

    /**
     * Set up syncing
     */
    ngOnInit() {
        this.subscriptions.add(this.meta.subscribe(() => this.updateBreadcrumbsSubscription()));
        this.updateBreadcrumbsSubscription();
        this.initiated = true;
        this.detectChanges();
    }

    private updateBreadcrumbsSubscription() {
        this.breadcrumbsSubscription?.unsubscribe();
        this.breadcrumbsSubscription = this.meta.state?.breadcrumbs$.subscribe(breadcrumbs => {
            if (this.breadcrumbs !== breadcrumbs) {
                this.breadcrumbs = breadcrumbs;
                this.detectChanges();
            }
        });
    }

    /**
     * Update on changes
     */
    ngOnChanges() {
        this.detectChanges();
    }

    /**
     * Cleanup
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.breadcrumbsSubscription?.unsubscribe();
    }

    /**
     * Change detection
     */
    private detectChanges() {
        this.ref.detectChanges();
    }

    /**
     * Helper method to tak all the crumbs possible
     *
     * @deprecated Set homeTitle option in core module import and use breadcrumbs directly instead
     * We need to have consistent data in here and in structural data (requires df-core 1.1.38+)
     */
    getAllCrumbs(label: string): ICrumb[] {
        return this.breadcrumbs ? [{ url: '/', label }, ...this.breadcrumbs.filter(i => i.url !== '/')] : [];
    }

    /**
     * Tests if a crumb points to current model (that is only for the last crumb)
     */
    isSelfLocation(crumb: ICrumb): boolean {
        return crumb.url === this.meta.model?.data?.url;
    }
}
